import { useSelector } from 'react-redux';

import { selectedLicenseTypeNatureSelector } from '../store/selectors';
import { getTabIndexes } from '../helpers/getTabIndexes';

function useTabIndexes() {
  const licenseTypeNature = useSelector(selectedLicenseTypeNatureSelector);

  return getTabIndexes(licenseTypeNature);
}

export default useTabIndexes;
